import React from 'react'
import * as T from '../../../../../../../components/Table'
import { FaWhatsapp, FaPhone, FaRegTrashAlt } from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'
import { Icon, Flex, Text, Spinner, Tooltip, Box } from '@chakra-ui/react'
import { useAgendamentoRetorno } from '../hooks/useAgendamentoRetorno'

export const Item = ({ agendamento }) => {
  const { deletarAgendamento } = useAgendamentoRetorno()

  const { mutateAsync, isLoading } = deletarAgendamento

  async function handleDelete() {
    await mutateAsync(agendamento.id_mensagem)
  }

  const Icons = {
    WHATSAPP: {
      bgColor: 'green.500',
      color: 'white',
      icon: FaWhatsapp,
    },
    TELEFONE: {
      bgColor: 'black',
      color: 'white',
      icon: FaPhone,
    },
    'E-MAIL': {
      bgColor: 'orange.500',
      color: 'white',
      icon: MdEmail,
    },
  }

  return (
    <T.Tr key={agendamento.id}>
      <T.Td>{agendamento.data_contato}</T.Td>
      <T.Td>{agendamento.data_agendamento}</T.Td>
      <T.Td>
        <Tooltip label={agendamento.observacoes} aria-label="A tooltip">
          <Text mx="auto" maxW="400px" isTruncated>
            {agendamento.observacoes}
          </Text>
        </Tooltip>
      </T.Td>
      <T.Td>
        <Flex alignItems="center" gap={2} justifyContent="center">
          <Icon
            as={Icons[agendamento.tipo_agendamento.toUpperCase()].icon}
            color={Icons[agendamento.tipo_agendamento.toUpperCase()].color}
            bgColor={Icons[agendamento.tipo_agendamento.toUpperCase()].bgColor}
            borderRadius="50%"
            w="25px"
            h="25px"
            p="2px"
          />
          {agendamento.tipo_agendamento}
        </Flex>
      </T.Td>
      <T.Td>
        <Tooltip label={<Box dangerouslySetInnerHTML={{ __html: agendamento.conteudo_retorno }} />} aria-label="A tooltip">
          <Text mx="auto" maxW="400px" isTruncated noOfLines={1} dangerouslySetInnerHTML={{ __html: agendamento.conteudo_retorno }} />
        </Tooltip>
      </T.Td>

      <T.Td>
        <Flex
          _hover={{
            bgColor: 'red.100',
          }}
          cursor="pointer"
          alignItems="center"
          gap={2}
          justifyContent="center"
          onClick={handleDelete}
        >
          {isLoading ? <Spinner size="sm" color="red.500" /> : <Icon as={FaRegTrashAlt} fontSize="18px" color="red.500" />}
        </Flex>
      </T.Td>
    </T.Tr>
  )
}
